export default __webpack_public_path__ + "static/media/team85.f1da7e68.JPG";